import script from "./other.vue?vue&type=script&lang=ts&setup=true"
export * from "./other.vue?vue&type=script&lang=ts&setup=true"

import "./other.vue?vue&type=style&index=0&id=7ec999a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec999a8"]])

export default __exports__